module.exports = __webpack_public_path__ + "static/exhi.2fd1a240.jpg";